import React from 'react';
import { IProps } from './type';

const ThumbIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_10700_34805)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.99881 6.40795C10.3638 6.11189 10.8878 5.97559 11.5863 5.97559C13.0117 5.97559 13.7437 7.12115 13.7437 8.10881V9.75277C13.7437 10.0289 13.9675 10.2528 14.2437 10.2528H17.1847C18.6055 10.2528 19.5732 11.6927 19.0366 13.0082L17.3712 17.0909C17.1409 17.6554 16.5919 18.0243 15.9823 18.0243H6.06982C5.2414 18.0243 4.56982 17.3527 4.56982 16.5243V11.7528C4.56982 10.9243 5.2414 10.2528 6.06982 10.2528H8.51049C8.6721 10.2528 8.75677 10.1881 8.78636 10.1382C9.01902 9.7466 9.17194 9.2211 9.27437 8.69956C9.34976 8.31568 9.39176 7.97151 9.42461 7.70223C9.43651 7.60473 9.44721 7.51705 9.45786 7.44086C9.50289 7.11877 9.62106 6.71437 9.99881 6.40795ZM10.6288 7.18455C10.5305 7.26432 10.4765 7.37718 10.4482 7.57932C10.4406 7.63389 10.4319 7.70553 10.4215 7.79056C10.3885 8.06136 10.3389 8.46804 10.2556 8.89227C10.1459 9.45105 9.96639 10.1098 9.6461 10.649C9.38651 11.086 8.91509 11.2528 8.51049 11.2528H6.06982C5.79368 11.2528 5.56982 11.4766 5.56982 11.7528V16.5243C5.56982 16.8005 5.79368 17.0243 6.06982 17.0243H15.9823C16.1855 17.0243 16.3685 16.9013 16.4453 16.7132L18.1107 12.6305C18.379 11.9727 17.8951 11.2528 17.1847 11.2528H14.2437C13.4152 11.2528 12.7437 10.5812 12.7437 9.75277V8.10881C12.7437 7.55907 12.3516 6.97559 11.5863 6.97559C10.9959 6.97559 10.7399 7.09442 10.6288 7.18455Z"
          fill="#212121" />
        <path d="M8.46069 11.2505L8.46069 16.8569"
          stroke={strokeColor ? strokeColor : "#212121"}
          strokeLinecap="square" />
      </g>
      <defs>
        <clipPath id="clip0_10700_34805">
          <rect
            width={width ? width : '24'}
            height={height ? height : '24'}
            fill={fillColor ? fillColor : "white"} />
        </clipPath>
      </defs>
    </svg>
  )
};

export default ThumbIcon;
